import { apiFetch } from '../config/api';

export function logError(type: string, message: string, details?: unknown): void {
  apiFetch('/api/client-errors', {
    method: 'POST',
    body: JSON.stringify({
      type,
      message: String(message).slice(0, 1000),
      details,
      url: window.location.href,
      userAgent: navigator.userAgent,
    }),
  }).catch(() => {}); // fire-and-forget
}
